import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {editAcCategoryData, getAcCategoryData,} from "../../../redux/modules/AcCategory/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class AcCategoryEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
        };
    }

    componentDidMount() {
        this.props.getAcCategoryData(this.props.match.params.id);
    }

    UNSAFE_componentWillReceiveProps = (np) => {
        this.setState({
            name: np.acCategory.data.name,
            description: np.acCategory.data.description,
        });
    };

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.editAcCategoryData(this.props.match.params.id, this.state);
    }

    render() {
        if (this.props.acCategory?.success) return <Redirect to="/ac-category"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"name"}
                            label={"Access category name"}
                            value={this.state.name}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    acCategory: state.acCategory,
});

const mapDispatchToProps = {
    getAcCategoryData,
    editAcCategoryData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(AcCategoryEdit)
);
